import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll({ children }) {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.25,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1.1,
            touchMultiplier: 1.4,
        });

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);

        // Anchor scroll handler
        const handleAnchor = (e) => {
            const link = e.target.closest("a[href^='#']");
            if (!link) return;
            const id = link.getAttribute("href").slice(1);
            const el = document.getElementById(id);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -80, duration: 1.4 });
            }
        };
        document.addEventListener("click", handleAnchor);

        return () => {
            document.removeEventListener("click", handleAnchor);
            lenis.destroy();
        };
    }, []);

    return children;
}
